module.exports = __webpack_public_path__ + "img/support.71bebc4b.png";